import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/whg-park/api/activityItem/findActivityOrderCheck',
    method: 'post',
    data: data
  });
}